import { SiteConfig } from '../config';

// Import does not seem to work with this package -- Algolia doesn't use import
// in its documentation and when you import it none of the methods are available
// eslint-disable-next-line @typescript-eslint/no-var-requires
const searchInsights = require('search-insights');

searchInsights('init', {
    appId: SiteConfig.algoliaAppId,
    apiKey: SiteConfig.algoliaApiKey,
});

export default searchInsights;
